import type { AxiosResponse } from "axios";
import axios from "axios";
import axiosOnSuccessEvent from "utils/axiosOnSuccessEvent";

type noembedResponseType = {
    width: number;
    author_name: string;
    author_url: string;
    version: string;
    provider_url: string;
    provider_name: string;
    thumbnail_width: number;
    thumbnail_url: string;
    height: number;
    thumbnail_height: number;
    html: string;
    url: string;
    type: string;
    title: string;
};

export const getTumbnailsFromVideoUrl = async (url: string): Promise<string> => {
    try {
        const response: AxiosResponse<noembedResponseType> = await axios.get(
            `https://noembed.com/embed?url=${url}`
        );

        axiosOnSuccessEvent(response);

        return response.data.thumbnail_url;
    } catch {
        return "";
    }
};
